import React, { useEffect, useState } from "react";
import { api, resolveImg } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";
import { BookButton } from "@/components/site/BookButton";
import { Seo } from "@/components/site/Seo";
import { useSite } from "@/context/SiteContext";

export default function About() {
  const { settings } = useSite();
  const [staff, setStaff] = useState([]);
  useEffect(() => {
    api.get("/staff").then((r) => setStaff(r.data)).catch(() => {});
  }, []);
  const doc = staff[0];

  return (
    <div>
      <Seo title="About Dr. Brandon Van Anne | Psalm 30:2 Chiropractic Gardner KS" description="Meet Dr. Brandon Van Anne and the story behind Psalm 30:2 Chiropractic in Gardner, Kansas." />
      <section className="pt-36 lg:pt-48 pb-20 px-6 md:px-10 lg:px-14">
        <div className="max-w-[1500px] mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-5">
            <div className="overflow-hidden rounded-sm aspect-[4/5] bg-linen">
              {doc?.image && (
                <img src={resolveImg(doc.image)} alt={doc?.name || "Dr. Brandon Van Anne"} className="w-full h-full object-cover" />
              )}
            </div>
          </Reveal>
          <div className="lg:col-span-7">
            <Reveal><div className="overline mb-6">About the Practice</div></Reveal>
            <Reveal delay={80}>
              <h1 className="font-serif font-light text-5xl lg:text-7xl leading-[1.0] text-espresso">{doc?.name || "Dr. Brandon Van Anne"}</h1>
              <div className="text-taupe uppercase tracking-[0.16em] text-xs mt-4">{doc?.role}</div>
            </Reveal>
            <Reveal delay={160}>
              <p className="mt-8 text-lg lg:text-xl font-light leading-relaxed text-espressosoft/85 max-w-xl">{doc?.bio}</p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-espresso text-ivory py-28 lg:py-40 px-6 text-center" data-testid="about-scripture">
        <Reveal>
          <div className="overline !text-brass mb-10">Our Namesake</div>
          <blockquote className="font-serif font-light italic text-3xl sm:text-4xl lg:text-6xl leading-[1.2] max-w-4xl mx-auto text-ivory/90">
            "{settings?.scripture || "O LORD my God, I cried to You for help, and You healed me."}"
          </blockquote>
          <div className="mt-8 text-xs uppercase tracking-[0.25em] text-ivory/50">{settings?.scripture_ref || "Psalm 30:2 (ESV)"}</div>
        </Reveal>
      </section>

      <section className="bg-ivory py-24 lg:py-32 px-6 md:px-10 lg:px-14" data-testid="about-values">
        <div className="max-w-[1500px] mx-auto grid md:grid-cols-3 gap-12">
          {[
            ["Individualized", "Longer appointment options and care built around your goals — not a template."],
            ["Hands-On", "Skilled manual care combined with functional movement and myofascial work."],
            ["Family-Centered", "A genuinely welcoming place for every member of your family, rooted in faith and care for our community."],
          ].map(([t, d], i) => (
            <Reveal key={t} delay={i * 80}>
              <div className="border-t border-espresso/15 pt-6">
                <h3 className="font-serif text-3xl text-espresso mb-3">{t}</h3>
                <p className="text-espressosoft/75 font-light leading-relaxed">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="text-center mt-20">
          <BookButton label="Book With Dr. Van Anne" variant="primary" track_label="about" testid="about-book-button" />
        </div>
      </section>
    </div>
  );
}
